import { connect } from 'react-redux'
import { showModal } from 'redux/modules/modals'
import AdminProductsComponent from '../components/AdminProductsComponent'

const mapActionCreators = {
  showModal
}

const mapStateToProps = state => {
  return {
    products: state.products.list,
    categories: state.categories.list,
    taxes: state.settings.taxes
  }
}

export default connect(mapStateToProps, mapActionCreators)(
  AdminProductsComponent
)



// WEBPACK FOOTER //
// ./src/routes/Admin/Products/containers/AdminProductsContainer.js